export default __webpack_public_path__ + "static/media/logo-text.82e9ce29.png";